export default "__VITE_ASSET__c63abb3d__"